import api from '../config/api';
import { ContactRequest, ContactResponse } from '../types/contact';

export class ContactService {
  static async createContact(contactData: ContactRequest): Promise<ContactResponse> {
    const response = await fetch(`${api.baseURL}${api.endpoints.contacts}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  static async getAllContacts(): Promise<ContactResponse[]> {
    const response = await fetch(`${api.baseURL}${api.endpoints.contacts}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  static async getContactsByType(type: 'BUSINESS' | 'RECOMMENDATION'): Promise<ContactResponse[]> {
    const response = await fetch(`${api.baseURL}${api.endpoints.contacts}/type/${type}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
}